import { IoIosInformationCircleOutline } from "react-icons/io";
import Lable from "./Lable";
import Tooltip from "./Tooltip/Tooltip";

export const FormField = ({
  label,
  tooltip,
  children,
  className = "",
}) => (
  <div className={`form-field ${className}`}>
    <div className="flex gap-1 items-center relative">
      <Lable lable={label} />

      {tooltip ? (
        <div className="relative group flex items-center">
          <IoIosInformationCircleOutline
            size={16}
            className="cursor-pointer text-gray-500"
          />

          <div
            className="
              absolute 
              left-5 
              top-0
              hidden 
              group-hover:block
              bg-black
              text-white
              text-xs
              px-3
              py-2
              rounded
              shadow-lg
              z-50
              max-w-[220px]
              whitespace-normal
              break-words
            "
          >
            {tooltip}
          </div>
        </div>
      ) : null}
    </div>

    {children}
  </div>
);